import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

export const performTokenRefresh = async () => {
  const storedRefresh = localStorage.getItem('refreshToken');
  if (!storedRefresh) throw new Error('No refresh token available');

  const response = await axios.post(`${API_BASE_URL}/auth/refreshtoken`, {
    refreshToken: storedRefresh,
  });

  const { token: newAccessToken, refreshToken: newRefreshToken } = response.data;
  localStorage.setItem('token', newAccessToken);
  if (newRefreshToken) localStorage.setItem('refreshToken', newRefreshToken);
  return newAccessToken;
};
